import { useMemo } from "react";
import { qrMatrix } from "../lib/qrcode";

/**
 * QR Code em SVG (sem dependência externa).
 * Usado para o parceiro escanear com o próprio celular e abrir a ficha lá.
 */
export default function QRCode({ value, size = 180, quiet = 4, dark = "#0f172a", light = "#ffffff", style }) {
  const matrix = useMemo(() => {
    try { return qrMatrix(value || ""); } catch { return null; }
  }, [value]);

  if (!matrix) return null;

  const n = matrix.length;
  const total = n + quiet * 2;
  // Um único path com todos os módulos escuros — leve e sem serrilhado no zoom.
  let d = "";
  for (let y = 0; y < n; y++) {
    let x = 0;
    while (x < n) {
      if (!matrix[y][x]) { x++; continue; }
      let run = 1;
      while (x + run < n && matrix[y][x + run]) run++;
      d += `M${x + quiet} ${y + quiet}h${run}v1h-${run}z`;
      x += run;
    }
  }

  return (
    <svg
      viewBox={`0 0 ${total} ${total}`}
      width={size}
      height={size}
      shapeRendering="crispEdges"
      role="img"
      aria-label="QR Code do formulário de credenciamento"
      style={{ display: "block", borderRadius: 8, ...style }}
    >
      <rect width={total} height={total} fill={light} />
      <path d={d} fill={dark} />
    </svg>
  );
}
